export const sentryConfig: SentryConfig = {
    sentrySupport: false,
    environment: 'Development',
    branch: 'feature-sentry',
    version: '1.0.0.0',
    processName: 'SelfService',
    clientId: 'D8DD3ADA-87F1-40F3-A606-D1C6DC423591'
};

interface SentryConfig {
    sentrySupport: boolean;
    environment: string;
    branch: string;
    version: string;
    processName: string;
    clientId: string;
}
